<template>
  <div>
    <div class="mail-box-header">
      <form class="row" v-on:submit.prevent="searchParks()">
        <div class="col-lg-4">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="buscar pelo nome"
              v-model="searchForm.form.parkName"
            />
          </div>
        </div>

        <div class="col-lg-4">
          <div class="input-group-btn col-lg-12">
            <button type="submit" class="btn btn-sm btn-primary">
              <i class="fa fa-search"></i>
              buscar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <th>tolerancia</th>
            <th>
              relacionado<br />
              com agenda
            </th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(park, key) in parksList.list" :key="key">
            <td>{{ park.parkName }}</td>

            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Tolerancia"
                  v-model="park.continuousTolerance"
                />
              </div>
            </td>
            <td @click.prevent="relatePark(park._id, park.continuousTolerance)">
              <switches
                v-model="park.related"
                theme="bootstrap"
                color="success"
                :emit-on-mount="false"
              ></switches>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Switches from 'vue-switches';
export default {
  components: { Switches },
  props: {
    selectedSchedule: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      searchForm: {
        form: {
          parkName: '',
        },
      },
      parksList: {
        originalList: [],
        list: [],
      },
    };
  },

  mounted() {
    this.ListParks();
  },
  watch: {
    'searchForm.form.parkName'() {
      this.searchParks();
    },
    selectedSchedule() {
      this.ListParks();
    },
  },
  methods: {
    async ListParks() {
      const parksList = await this.$store.dispatch('PARKING/GetParkList');
      const formattedParks = parksList.map(park => ({
        ...park,
        related: String(park.tariffSchedule) === String(this.selectedSchedule),
      }));

      this.parksList.originalList = formattedParks;
      this.searchParks();
    },
    searchParks() {
      const listFiltered = this.parksList.originalList.filter(item => {
        return (
          item.parkName
            .toUpperCase()
            .indexOf(this.searchForm.form.parkName.toUpperCase()) > -1
        );
      });
      this.parksList.list = listFiltered;
    },
    async relatePark(parkId, continuousTolerance) {
      if (!this.selectedSchedule) {
        return;
      }
      try {
        await this.$store.dispatch('RELATE/RelatePark', {
          tariffScheduleId: this.selectedSchedule,
          parkId,
          continuousTolerance: continuousTolerance
            ? Number(continuousTolerance)
            : null,
        });
        await this.ListParks();
        this.$toasted.success('Estacionamento relacionado com sucesso!');
      } catch (error) {
        this.$toasted.error('Não foi possível relacionar estacionarmento');
      }
    },
  },
};
</script>